import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const CompetitionSeasonAPI = {
	listForCurrentUser: async (params) =>
		(
			await api.request({
				method: "GET",
				url: apiUrl + "/CompetitionsSeasons/ForCurrentUser",
				params,
				useAuthInterceptor: true,
			})
		).data,
	getForCurrentUser: async (id, params) =>
		(
			await api.request({
				method: "GET",
				url: apiUrl + "/CompetitionsSeasons/ForCurrentUser/" + id,
				params,
				useAuthInterceptor: true,
			})
		).data,
	list: async (params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/competitionsseasons",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/competitionsseasons/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/competitionsseasons",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/competitionsseasons/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/competitionsseasons/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},

	// Rounds (Giornate/Turni)
	createRound: async (competitionSeasonId, groupId, data) => {
		const response = await api.request({
			method: "POST",
			url: `${apiUrl}/competitionsseasons/${competitionSeasonId}/groups/${groupId}/rounds`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},
	updateRound: async (competitionSeasonId, groupId, roundId, data) => {
		const response = await api.request({
			method: "PUT",
			url: `${apiUrl}/competitionsseasons/${competitionSeasonId}/groups/${groupId}/rounds/${roundId}`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},
	deleteRound: async (
		competitionSeasonId,
		groupId,
		roundId,
		deleteMatches = false,
	) => {
		const response = await api.request({
			method: "DELETE",
			params: {deleteMatches},
			url: `${apiUrl}/competitionsseasons/${competitionSeasonId}/groups/${groupId}/rounds/${roundId}`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	addMatchToRound: async (competitionSeasonId, groupId, roundId, matchId) => {
		const response = await api.request({
			method: "POST",
			url: `${apiUrl}/competitionsseasons/${competitionSeasonId}/groups/${groupId}/rounds/${roundId}/matches/${matchId}`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	removeMatchFromRound: async (
		competitionSeasonId,
		groupId,
		roundId,
		matchId,
	) => {
		const response = await api.request({
			method: "DELETE",
			url: `${apiUrl}/competitionsseasons/${competitionSeasonId}/groups/${groupId}/rounds/${roundId}/matches/${matchId}`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},

	updateParticipant: async (id, participantId, data) =>
		api.request({
			method: "PUT",
			url:
				apiUrl +
				"/CompetitionsSeasons/" +
				id +
				"/participants/" +
				participantId,
			data,
			useAuthInterceptor: true,
		}),
	addParticipant: async (id, data) =>
		(
			await api.request({
				method: "POST",
				url: apiUrl + "/CompetitionsSeasons/" + id + "/participants",
				data,
				useAuthInterceptor: true,
			})
		).data,
	deleteParticipant: async (id, participantId) =>
		api.request({
			method: "DELETE",
			url:
				apiUrl +
				"/CompetitionsSeasons/" +
				id +
				"/participants/" +
				participantId,
			useAuthInterceptor: true,
		}),
	linkParticipant: async (id, groupId, participantId, remove = false) =>
		api.request({
			method: remove ? "DELETE" : "POST",
			url:
				apiUrl +
				"/CompetitionsSeasons/" +
				id +
				"/groups/" +
				groupId +
				"/participants/" +
				participantId,
			useAuthInterceptor: true,
		}),
	// Groups (Gironi)
	createGroup: async (competitionSeasonId, data) => {
		const response = await api.request({
			method: "POST",
			url: `${apiUrl}/competitionsseasons/${competitionSeasonId}/groups`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},
	updateGroup: async (competitionSeasonId, groupId, data) => {
		const response = await api.request({
			method: "PUT",
			url: `${apiUrl}/competitionsseasons/${competitionSeasonId}/groups/${groupId}`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});
		return response.data;
	},
	deleteGroup: async (competitionSeasonId, groupId) => {
		const response = await api.request({
			method: "DELETE",
			url: `${apiUrl}/competitionsseasons/${competitionSeasonId}/groups/${groupId}`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	addRosterToGroup: async (competitionSeasonId, groupId, rosterId) => {
		const response = await api.request({
			method: "POST",
			url: `${apiUrl}/competitionsseasons/${competitionSeasonId}/groups/${groupId}/rosters/${rosterId}`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	removeRosterFromGroup: async (competitionSeasonId, groupId, rosterId) => {
		const response = await api.request({
			method: "DELETE",
			url: `${apiUrl}/competitionsseasons/${competitionSeasonId}/groups/${groupId}/rosters/${rosterId}`,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
};
